import { render, staticRenderFns } from "./DocumentComplianceReview.vue?vue&type=template&id=c5c7db0c&scoped=true&"
import script from "./DocumentComplianceReview.vue?vue&type=script&lang=js&"
export * from "./DocumentComplianceReview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentComplianceReview.vue?vue&type=style&index=0&id=c5c7db0c&prod&lang=scss&"
import style1 from "./DocumentComplianceReview.vue?vue&type=style&index=1&id=c5c7db0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c7db0c",
  null
  
)

export default component.exports